module.exports = __webpack_public_path__ + "img/tackled_right.bb779a0d.jpg";